// extracted by mini-css-extract-plugin
export default {"xxlBreakPoint":"1440px","extraLargeBreakPoint":"1200px","largeBreakPoint":"1000px","mobileBreakPoint":"750px","pagination":"styles_pagination__GVtU-","title":"styles_title__55G8p"};